import { SearchFcrTypesDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectFcrReason = (props) => (
  <SelectFromQuery
    cache="FcrTypes"
    placeholder="Reason"
    query={SearchFcrTypesDocument}
    selector={(data) =>
      (data?.searchFcrTypes?.fcrTypeConnection?.edges || []).map((opt) => ({
        label: opt?.node?.name,
        value: opt?.node?.name,
      }))
    }
    {...props}
  />
);

export default SelectFcrReason;
